import React from 'react';
import CancelCreate from '../../../controllers/CancelCreate';
import SaveDraft from '../../../controllers/SaveDraft';
import SaveAcceptance from '../../../controllers/SaveAcceptance';
import AcceptanceName from '../../../../../controllers/AcceptanceName';
import styles from './index.module.scss';
import commonSyles from '../index.module.scss';

const AcceptanceSetup = () => {
  return (
    <>
      <AcceptanceName
        className={commonSyles.acceptanceName}
        mode={AcceptanceName.modes.editable}
      />
      <div className={styles.rightCol}>
        <CancelCreate />
        {/* <SaveDraft /> */}
        <SaveAcceptance />
      </div>
    </>
  );
};

export default AcceptanceSetup;
